<template>
  <div class="wrap f-question">
    <span class="title">常见问题</span>
    <div class="list">
      <ul class="ul-cls">
        <li v-for="item in list1" :key="item.id">
          <router-link :to="{path:`/search/detail/${item.id}`}">
            <span class="tag"></span>
            {{item.listTitle}}
          </router-link>
        </li>
      </ul>
      <ul class="ul-cls">
        <li v-for="item in list2" :key="item.id">
          <router-link :to="{path:`/search/detail/${item.id}`}">
            <span class="tag"></span>
            {{item.listTitle}}
          </router-link>
        </li>
      </ul>
      <ul class="ul-cls">
        <li v-for="item in list3" :key="item.id">
          <router-link :to="{path:`/search/detail/${item.id}`}">
            <span class="tag"></span>
            {{item.listTitle}}
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import './style.scss';
</style>

<script>
export default {
  data() {
    return {
      questList: [],
      list1: [],
      list2: [],
      list3: [],
    };
  },
  created() {
    this.$store.dispatch('list/getHelpList', {
      pageNum: 1,
      pageSize: 12,
      concludeTag: true,
      tagNames: '常见问题',
    }).then((data) => {
      const { list } = data;
      this.questList = list;
      if (list) {
        this.questList.forEach((item, index) => {
          if (index < 4) {
            this.list1.push(item);
          } else if (index < 8) {
            this.list2.push(item);
          } else {
            this.list3.push(item);
          }
        });
      }
    });
  },
};
</script>
